/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ConnectorToPricingScheduleGroupDto } from "./ConnectorToPricingScheduleGroupDto";
import {
    ConnectorToPricingScheduleGroupDtoFromJSON,
    ConnectorToPricingScheduleGroupDtoFromJSONTyped,
    ConnectorToPricingScheduleGroupDtoToJSON,
} from "./ConnectorToPricingScheduleGroupDto";

/**
 *
 * @export
 * @interface ConnectorPricingScheduleListResponse
 */
export interface ConnectorPricingScheduleListResponse {
    /**
     *
     * @type {Array<ConnectorToPricingScheduleGroupDto>}
     * @memberof ConnectorPricingScheduleListResponse
     */
    connectorSchedules?: Array<ConnectorToPricingScheduleGroupDto>;
}

/**
 * Check if a given object implements the ConnectorPricingScheduleListResponse interface.
 */
export function instanceOfConnectorPricingScheduleListResponse(
    value: object,
): value is ConnectorPricingScheduleListResponse {
    return true;
}

export function ConnectorPricingScheduleListResponseFromJSON(
    json: any,
): ConnectorPricingScheduleListResponse {
    return ConnectorPricingScheduleListResponseFromJSONTyped(json, false);
}

export function ConnectorPricingScheduleListResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ConnectorPricingScheduleListResponse {
    if (json == null) {
        return json;
    }
    return {
        connectorSchedules:
            json["connectorSchedules"] == null
                ? undefined
                : (json["connectorSchedules"] as Array<any>).map(
                      ConnectorToPricingScheduleGroupDtoFromJSON,
                  ),
    };
}

export function ConnectorPricingScheduleListResponseToJSON(
    value?: ConnectorPricingScheduleListResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        connectorSchedules:
            value["connectorSchedules"] == null
                ? undefined
                : (value["connectorSchedules"] as Array<any>).map(
                      ConnectorToPricingScheduleGroupDtoToJSON,
                  ),
    };
}
